<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'orderlog' + (order ? order.id : '')">
      <slot></slot>
    </span>
    <el-dialog top="0vh" v-if="dialogFormVisible" class="el-dialog-sm custom-width-dialog-900"
      :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%">
      <h2 style="text-align: center;margin-bottom:30px;">操作日志</h2>
      <el-table :data="logs">
        <el-table-column width="200" property="operation_time" label="操作时间"></el-table-column>
        <el-table-column width="100" property="operator" label="操作人"></el-table-column>
        <el-table-column label="操作内容" property="operation_content"></el-table-column>
        <!--<el-table-column label="备注">
          <template slot-scope="scope">
            <div>
              {{ scope.row.data && scope.row.data.amount? scope.row.api_cn+'￥'+scope.row.data.amount : scope.row.api_cn }}
            </div>
          </template>
        </el-table-column>-->
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'AddTicket',
  props: ['order'],
  data() {
    return {
      logs: [],
      isSubmitting: false,
      dialogFormVisible: false
    }
  },
  async mounted() {

  },
  methods: {
    getDetail(row){
      if(row.api_cn=='取消订单'){
        return row.api_cn+'，原因：'+row.data.reason
      }
      else if(row.data && row.data.amount){
        return row.api_cn+(row.api_cn.toLowerCase().indexOf('alpha')>-1?'('+row.alphapay_type+')':'')+'￥'+row.data.amount
      }
      else{
        return row.api_cn
      }
    },
    show() {
      this.getLogs();
      this.dialogFormVisible = true
      //this.$set(this.r,'topic','主题')
      //this.$set(this.r,'description','描述内容')

    },
    async getLogs() {
      let res = await api.get(this, {
        path: 'order.php',
        api: 'get_op_log_list',
        params: {
          order_id:this.order.id
        },
        loading: 'loading'
      })
      res = res.body
      this.isSubmitting = false
      if (res.status == 'ok') {
        this.logs = res.result;
      }
    }
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/OrderLogs.vue